export default __webpack_public_path__ + "images/67f7f55e01ed1fd2533dbd32213c4485.png";